import { CssBaseline, ThemeProvider } from "@mui/material";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider as DateProvider } from "@mui/x-date-pickers/LocalizationProvider";
import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider as QueryProvider } from "react-query";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import { store } from "./app/store";
import theme from "./styles/theme";
const container = document.getElementById("root");
const root = createRoot(container);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      staleTime: 5 * 60 * 1000,
    },
  },
});
root.render(
  <StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <DateProvider dateAdapter={AdapterMoment}>
          <CssBaseline />
          <Router basename={process.env.PUBLIC_URL}>
            <QueryProvider client={queryClient}>
              <App />
            </QueryProvider>
          </Router>
        </DateProvider>
      </ThemeProvider>
    </Provider>
  </StrictMode>
);
